export function getCmdCtrlSymbol() {
  let symbol = '⌘';

  if (typeof window !== 'undefined') {
    if (window.navigator?.platform?.toUpperCase()?.indexOf('MAC') === -1) {
      symbol = 'Ctrl';
    }
  }

  return symbol;
}
